import Card from "components/CardSelector/Card";
import {
  BaseDropdown,
  LargeButton,
  MainBody,
  OverlayLoader,
  PageTitle,
  Ptag,
} from "components/core";
import React, { useEffect, useMemo, useState } from "react";
import useFetchWellness from "./useFetchWellness";
import { BenefitsContainer } from "./styles";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { useLocation, useNavigate } from "react-router";
import { SideNav } from "components";

const validationSchema = Yup.object().shape({
  // vendor: Yup.string().required("*required"),
  vendor: Yup.string(),
});

function Wellness() {
  const navigate = useNavigate();
  let location = useLocation();
  const isOldFlow = useMemo(() => {
    if (location?.pathname.includes("v1")) {
      return false;
    }
    return true;
  }, [location]);
  const {
    benefits,
    vendorOptions,
    loading,
    locallySaveBenefitsVendor,
    getBenefitMapping,
    mapWellnessBenefit,
  } = useFetchWellness(true);
  const [selectedBenefits, setSelectedBenefits] = useState(new Set());
  const [initialValues, setInitialValues] = useState({
    vendor: "",
  });

  const onChange = (value, list, set) => {
    const newSet = new Set(list);
    if (list.has(value)) {
      newSet.delete(value);
      set(newSet);
    } else {
      newSet.add(value);
      set(newSet);
    }
  };

  useEffect(() => {
    (async function () {
      const { benefits, marketplace_vendor } = await getBenefitMapping();
      if (benefits?.length) {
        const selectedBenefits = benefits.map(({ benefit }) => benefit);
        setSelectedBenefits(new Set([...selectedBenefits]));
      }
      if (marketplace_vendor) {
        setInitialValues({
          vendor: marketplace_vendor?.vendor,
        });
      }
    })();
  }, []);

  const handleSubmit = async (values) => {
    if (!selectedBenefits.size) {
      alert("Please select at least one benefit!");
      return;
    }
    const payload = {
      benefits: [...selectedBenefits],
      marketplace_vendor: values.vendor,
    };
    await mapWellnessBenefit(payload);
    locallySaveBenefitsVendor({
      selectedBenefits: [...selectedBenefits],
      ...values,
    });
    if (isOldFlow) {
      navigate("/wellness/setup");
      return;
    }
    navigate("/v1/wellness/setup");
  };

  if (loading) return <OverlayLoader />;

  return (
    <>
      {isOldFlow && <SideNav></SideNav>}
      <div>
        {isOldFlow ? (
          <MainBody style={{height : "100vh",
             display: "flex",
    flexDirection: "column", 
          }}>
            <PageTitle title="Health & Wellness Benefits"></PageTitle>
            <Formik
              enableReinitialize
              validationSchema={validationSchema}
              initialValues={initialValues}
              onSubmit={handleSubmit}
            >
              {(formikProps) => {
                // const isButtonDisabled = !selectedBenefits.size || !formikProps.values.vendor;
                const isButtonDisabled = !selectedBenefits.size;
                return (
                  <Form  style={{
                      display: "flex",
                      flexDirection: "column",
                      flex: 1,
                      minHeight: 0
                    }}>
                    <Ptag fontSize="18px" marginBottom="14px">
                      Select Benefits
                    </Ptag>
                    <BenefitsContainer>
                      {benefits.map(({ display_name, id }) => (
                        <Card
                          key={id}
                          title={display_name}
                          selected={selectedBenefits.has(id)}
                          onChange={() =>
                            onChange(id, selectedBenefits, setSelectedBenefits)
                          }
                        />
                      ))}
                    </BenefitsContainer>
                    {/* <Ptag fontSize="18px" marginBottom="14px" marginTop="46px">
                      Select Marketplace Vendor (Optional)
                    </Ptag> */}

                    {/* <BaseDropdown
                      width={"85%"}
                      fontSize="14"
                      options={vendorOptions}
                      formikProps={{ ...formikProps, name: "vendor" }}
                    /> */}

                    <LargeButton
                      type="submit"
                      style={{
                        marginTop: "auto",
                        opacity: isButtonDisabled ? 0.6 : 1,
                        pointerEvents: isButtonDisabled ? "none" : "auto",
                        width:"85%"
                      }}
                      label="Save & Next"
                      disabled={isButtonDisabled}
                    />
                  </Form>
                );
              }}
            </Formik>
          </MainBody>
        ) : (
          <Formik
            enableReinitialize
            validationSchema={validationSchema}
            initialValues={initialValues}
            onSubmit={handleSubmit}
          >
            {(formikProps) => {
              const isButtonDisabled = !selectedBenefits.size;
              return (
                <Form  style={{
                      display: "flex",
                      flexDirection: "column",
                      flex: 1,
                      minHeight: 0
                    }}>
                  <Ptag fontSize="18px" marginBottom="14px">
                    Select Benefits
                  </Ptag>
                  <BenefitsContainer>
                    {benefits.map(({ display_name, id }) => (
                      <Card
                        key={id}
                        title={display_name}
                        selected={selectedBenefits.has(id)}
                        onChange={() =>
                          onChange(id, selectedBenefits, setSelectedBenefits)
                        }
                      />
                    ))}
                  </BenefitsContainer>
                    {/* <Ptag fontSize="18px" marginBottom="14px" marginTop="46px">
                      Select Marketplace Vendor (Optional)
                    </Ptag> */}

                    {/* <BaseDropdown
                      width={"85%"}
                      fontSize="14"
                      options={vendorOptions}
                      formikProps={{ ...formikProps, name: "vendor" }}
                    /> */}
                  <LargeButton
                    type="submit"
                    style={{
                      marginTop: "auto",
                      opacity: isButtonDisabled ? 0.6 : 1,
                      pointerEvents: isButtonDisabled ? "none" : "auto",
                      width:"85%"
                    }}
                    label="Save & Next"
                    disabled={isButtonDisabled}
                  />
                </Form>
              );
            }}
          </Formik>
        )}
      </div>
    </>
  );
}

export default Wellness;
